// extracted by mini-css-extract-plugin
export default {"inner":"LoadingSpinner_inner__5Y+is","ldio-x60pcbbjc7":"LoadingSpinner_ldio-x60pcbbjc7__mVo0Y","container":"LoadingSpinner_container__Cq9gM","center":"LoadingSpinner_center__Jf-9w"};